import { SharedApplicationState } from '../shared-state.interface';
import { MhSelectionState } from './selection-state.entity';

export const selectFeature: (state: SharedApplicationState) => MhSelectionState = (state: SharedApplicationState) =>
    state.selection;

export function mediaHavenSelectionSelector(state: SharedApplicationState): MhSelectionState {
    return selectFeature(state);
}

export function shouldInitializeSelection(state: SharedApplicationState): boolean {
    return typeof selectFeature(state).selection === 'undefined' && !selectFeature(state).failed;
}
